import { FC } from "react"
import { CardProps } from "./types";


const CustomCardComponent: FC<CardProps> = ({ title , value }): JSX.Element => {
    return (
        <div className="col-xxl col-xl-3 col-lg-4 col-md-4 col-sm-4 d-flex">
            <div className="card d-flex flex-fill">
                <div className="card-header text-center px-2 flex-fill">
                    <h1 className="mt-2 mb-0">{title}</h1>
                </div>
                <div className="card-body text-center px-2">
                    <h1 className="mt-2 mb-0 fw-bold">{value}</h1>
                </div>
            </div>
        </div>
    )
}
export default CustomCardComponent;
